class HeroSlide extends HTMLElement {
    constructor() {
        super();
        this.slideContainer()
    }

    slideContainer() {
        document.addEventListener("DOMContentLoaded", function () {
            var swiper = new Swiper('.swiper-container', {
                loop: true,
                autoplay: {
                    delay: 6000,
                }
            });
        });
    }

}

customElements.define('hero-slide', HeroSlide);
